import React from "react";
import { CheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { images, volumes } from "../../data/content";
export function VolumesSection() {
  return <section className="bg-mist px-5 py-16 sm:py-20" data-id="element-311" data-mp="2munas7hskjcb">
      <div className="mx-auto max-w-6xl" data-id="element-312" data-mp="2rtgnhxp986bf">
        <SectionHeading kicker="What's inside?" title="Introducing the DENTAL BLEACHING BLUEPRINT™ Clinical Library" lead="6 specialized volumes designed to support your clinical learning. Each one addresses a different part of professional teeth whitening — together, an organized framework from assessment to maintenance." data-id="element-313" data-mp="2rs59z660bk74" />
        <img src={images.mockup} alt="The six volumes of the Dental Bleaching Blueprint" className="mx-auto mt-8 w-full max-w-[520px]" data-id="element-314" data-mp="292pamm625xsa" />

        <div className="mt-8 grid gap-5 md:grid-cols-2" data-id="element-315" data-mp="1v4iscedle6dq">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_10px_30px_-15px_rgba(10,31,68,0.35)]" data-id="element-316" data-mp="1z4svzkdwwkpf">
              <div className="px-5 pb-5 pt-6" style={{
            borderTop: `6px solid ${v.accent}`
          }} data-id="element-317" data-mp="1akfgz0yrjct4">
                <span className="inline-block rounded-full px-3 py-1 font-display text-[13px] font-black uppercase tracking-wide text-white" style={{
              backgroundColor: v.accent
            }} data-id="element-318" data-mp="1ph6aitlr9uat">
                  {v.number}
                </span>
                <h3 className="mt-3 font-display text-[22px] font-black leading-tight text-navy-950" data-id="element-319" data-mp="wqfygbs157rh">{v.title}</h3>
                <p className="mt-1.5 text-[15px] font-bold" style={{
              color: v.accent
            }} data-id="element-320" data-mp="16ibvrkmaktun">
                  {v.subtitle}
                </p>
                <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-321" data-mp="11r3mcokyp8hh">{v.intro}</p>
                <p className="mt-4 text-[13px] font-extrabold uppercase tracking-wide text-navy-950" data-id="element-322" data-mp="e199i70n7jx8">Inside this volume</p>
                <ul className="mt-2 space-y-2" data-id="element-323" data-mp="92ogosnq02it">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-324" data-mp="yqtxdthlhoy6">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-325" data-mp="12rduwy62yuku" />
                      {item}
                    </li>)}
                </ul>
              </div>
              <div className="mt-auto bg-navy-950 px-5 py-4 text-[15px] leading-snug text-white" data-id="element-326" data-mp="1ckurub1ikpsq">
                <span className="font-extrabold text-gold" data-id="element-327" data-mp="fuk9kegw5k0z">Your takeaway: </span>
                {v.takeaway}
              </div>
            </article>)}
        </div>
        <SectionCta label="Get instant access to all 6 volumes" note="The complete library for a one-time $27 USD" data-id="element-328" data-mp="orkxyl3yni4f" />
      </div>
    </section>;
}